<template>
  <div class="join-us-page">
    <div class="main-content">
      <!-- 英雄区 -->
      <section class="hero-section">
        <div class="container">
          <AppHeader />
          <div class="hero-content" ref="heroContent">
            <h1 class="hero-title animate-scroll">加入我们</h1>
            <h2 class="hero-subtitle animate-scroll">志同道合，一起远行</h2>
          </div>
        </div>
      </section>

      <!-- 职位列表区 -->
      <section class="jobs-section" ref="jobsSection">
        <div class="container">
          <h2 class="section-title animate-scroll">全部职位</h2>
          <div class="jobs-list">
            <div class="job-card animate-scroll" v-for="job in jobs" :key="job.id">
              <div class="job-title">{{ job.title }}</div>
              <div class="job-info">工作地点：{{ job.address }}</div>
              <div class="job-info">发布时间：{{ formatDate(job.createtime) }}</div>
              <div class="job-link" @click="goToJobDetail(job.id)">查看详细信息<span class="arrow">→</span></div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="footer-wrapper">
      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import AppFooter from '@/components/AppFooter.vue';
import { getJobList } from '@/api';

export default {
  name: 'JoinUsPage',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      jobs: [],
      page: 1,
      limit: 10,
      total: 0,
      jobsObserver: null
    }
  },
  created() {
    this.fetchJobs();
  },
  mounted() {
    this.$nextTick(() => {
      // 英雄区动画
      const heroContent = this.$refs.heroContent;
      if (heroContent) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const heroEls = entry.target.querySelectorAll('.animate-scroll');
              heroEls.forEach((el, idx) => {
                setTimeout(() => {
                  el.classList.add('visible');
                }, idx * 120);
              });
            }
          });
        }, { threshold: 0.1 });
        observer.observe(heroContent);
      }
    });
  },
  beforeUnmount() {
    if (this.jobsObserver) {
      this.jobsObserver.disconnect();
    }
  },
  methods: {
    async fetchJobs() {
      try {
        const res = await getJobList({
          page: this.page,
          limit: this.limit
        });
        if (res.data && res.code === 1) {
          this.jobs = res.data.data;
          this.total = res.data.total;
          this.$nextTick(() => {
            this.initJobsAnimation();
          });
        }
      } catch (error) {
        console.error('获取职位列表失败:', error);
      }
    },
    initJobsAnimation() {
      const jobsSection = this.$refs.jobsSection;
      if (jobsSection) {
        if (this.jobsObserver) this.jobsObserver.disconnect();
        this.jobsObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const cards = entry.target.querySelectorAll('.animate-scroll');
              cards.forEach((el, idx) => {
                setTimeout(() => {
                  el.classList.add('visible');
                }, idx * 120);
              });
            }
          });
        }, { threshold: 0.1 });
        this.jobsObserver.observe(jobsSection);
      }
    },
    goToJobDetail(id) {
      this.$router.push(`/job/${id}`);
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    }
  }
}
</script>

<style scoped>
.join-us-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: Arial, sans-serif;
  background: #fff;
}
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #F8F8F8;
}
.footer-wrapper {
  flex-shrink: 0;
}

.hero-section {
  width: 1920px;
  height: 600px;
  background-image: url('~@/assets/image/JoinUsPageBg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}
.container {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}
.hero-content {
  margin-top: 302px;
  color: #fff;
}
.hero-title {
  font-size: 40px;
  font-weight: 600;
  line-height: 56px;
  margin: 0;
}
.hero-subtitle {
  font-size: 26px;
  line-height: 37px;
  margin-top: 10px;
  font-weight: 400;
}

.jobs-section {
  width: 1920px;
  background: #F8F8F8;
  min-height: 378px;
  padding-bottom: 40px;
}
.section-title {
  font-size: 36px;
  font-weight: 600;
  color: #333;
  margin-top: 40px;
  margin-bottom: 40px;
  line-height: 50px;
}
.jobs-list {
  display: flex;
  gap: 30px;
}
.job-card {
  width: 350px;
  height: 208px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 30px;
  /* 动画样式 */
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 1s cubic-bezier(.4,0,.2,1), transform 1s cubic-bezier(.4,0,.2,1);
}
.job-card.visible {
  opacity: 1;
  transform: translateY(0);
}
.job-title {
  font-size: 24px;
  font-weight: 500;
  color: #333;
  margin-bottom: 20px;
}
.job-info {
  font-size: 18px;
  color: #666;
  margin-bottom: 10px;
}
.job-link {
  font-size: 18px;
  color: #3159B3;
  margin-top: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.arrow {
  margin-left: 4px;
}
.animate-scroll {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 1s ease, transform 1s ease;
}
.animate-scroll.visible {
  opacity: 1;
  transform: translateY(0);
}
</style> 